module.exports = __webpack_public_path__ + "img/ck.5bdb5c9b.svg";